import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import AxiosInstance from 'src/components/Axios';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderMenu({ params }) {
  let res = await AxiosInstance.get('/menus?page=' + page).then((response) => {
    return response;
  });
  // Фільтрація на клієнтській стороні - тільки ua або null мова
  res.data['hydra:member'] = res.data['hydra:member'].filter(menu =>
    menu?.language === undefined || menu?.language?.id === 1
  );

  return res;
}

const columns = [
  {
    field: 'id', headerName: 'ID',
    sortable: false,
    disableColumnMenu: true,
    width: 70
  },
  {
    field: 'name', headerName: 'Назва',
    sortable: false,
    disableColumnMenu: true,
    width: 200
  },
  {
    field: 'type', headerName: 'Тип',
    sortable: false,
    disableColumnMenu: true,
    width: 400
  },
  {
    field: "action",
    headerName: "Редагувати",
    sortable: false,
    headerName: "",
    headerClassName: "hide-header",
    align: 'center',
    width: 70,
    // renderCell: (params) => {
    //   return <Link to={'/menu/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
    // }
    renderCell: (params) => {
      return <Link to={'/menu/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
    }
  },
];


const Menu = ({ user_data }) => {

  if (!Permissions(user_data, 'Menu', 'VIEW_MENU')) {
    return <PermissionsNoPage />;
  }

  const { data } = useLoaderData();
  const [rows, setRows] = useState(data['hydra:member']);
  const postPerPage = 1;

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader className='items_card_header'>
            {/* <strong> */}
            Меню
            {/* </strong>  */}
            <small>*</small>
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_solo'>
              {<p className="text-medium-emphasis small">
                <Link to="/menu/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                  {/* Створити */}
                  Add
                </CButton></Link>
              </p>}
            </div>
            <div style={{ height: 400, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                rowsPerPageOptions={[postPerPage]}
                // checkboxSelection

                components={{ Pagination: CustomPagination }}
                headerHeight={44}

                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Menu;
